/* eslint-disable */
import girl1 from "../assets/svg/testimonials/girl1.svg";
import girl2 from "../assets/svg/testimonials/girl2.svg";
import girl3 from "../assets/svg/testimonials/girl3.svg";
import boy1 from "../assets/svg/testimonials/boy1.svg";
import boy2 from "../assets/png/boy_dev_2.png";
import boy from "../assets/png/boy_dev.png";
import girl from "../assets/png/girl_dev.png";

export const testimonialsData = [
  {
    id: 0.1,
    name: "Pankaj Sahni",
    title: "Senior Enginnering Manager at Nike",
    text: "MassBOM was at risk due to external dependencies. Bhaskar(Win as a Team) played a pivotal role by delivering major features at lightning speed, ensuring we met our deadlines.",
    image: boy,
  },
  {
    id: 0,
    name: "Srinath Kudal",
    title: "Enginnering Manager at Nike",
    text: "Bhaskar(Be on the Offense Always) has made an exceptional impact since joining out team one month ago. He developed multiple approaches for data storage in out frontend application, complete with performance metrics, which helped us select the optimal solution and significantly improve application performance. AS a new team member, his contributions exceed expectations, and his innovative thinking is truly next level.",
    image: boy,
  },
  {
    id: 1,
    name: "Prajwal Rathod",
    title: "Software Developer at InspironLabs",
    text: "Bhaskar - Exceptional Full Stack Developer and good problem solver. Their unparalleled technical prowess, dedication to excellence, and seamless teamwork make them an invaluable asset. Highly recommended!",
    image: boy,
  },
  {
    id: 2,
    name: "Gauri Patil",
    title: "Web developer at CDAC India",
    text: `It's been a pleasure collaborating with Bhaskar and witnessing their exceptional skills in action. Throughout our time working together, I've been consistently impressed by their ability to tackle challenges with creativity and perseverance. His problem-solving skills are truly remarkable, and he always approach projects with a positive and proactive attitude, inspiring the whole team. His expertise in the MERN stack has been invaluable, and their willingness to share knowledge and help others grow is commendable.
    Additionally, I must highlight his exceptional communication and teamwork skills. His ability to build strong relationships within the team and with clients has undoubtedly been a key factor in our collective success.`,
    image: girl,
  },
  {
    id: 3,
    name: "Asgar",
    title: "Web developer at RCS Tech",
    text: "I had the privilege of learning JavaScript and React.js from Bhaskar, an exceptional instructor. His deep expertise, patient teaching style, and passion for these technologies made the learning experience truly enjoyable and insightful. I highly recommend Bhaskar for anyone looking to master JavaScript and React.js.",
    image: boy2,
  },
  {
    id: 5,
    name: "Dharmesh Sonar",
    title: "Backend Developer at InspironLabs",
    text: "A brilliant Fullstack JavaScript Developer with whom I had the pleasure of working within the same team. His deep knowledge of JavaScript and full-stack development, coupled with his strong work ethic, consistently impressed me. Bhaskar's reliability and dedication have made him a valuable asset to our team, consistently delivering exceptional results. His collaboration and technical skills make him a standout professional.",
    image: boy,
  },
  {
    id: 5,
    name: "Vivek Rajput",
    title: "React Developer at InspironLabs",
    text: "I highly recommend Bhaskar for their exceptional skills in JavaScript, React, and Node.js. We collaborated on a project, and I was consistently impressed by their expertise and problem-solving abilities. Bhaskar is a valuable team player, and their code quality was top-notch. Their passion for technology and positive attitude made working together a pleasure. I highly recommend Bhaskar to any team in need of a talented developer.",
    image: boy2,
  },
];
